// gatsby-browser.js

import React from "react"
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent"
import "./src/components/output.css"

const GA_MEASUREMENT_ID = "G-71PEXD2E5S"

// Utility: inject the gtag <script> and run config()
function loadGoogleAnalytics() {
  if (window._gaLoaded) return
  // 1) Insert the external <script>
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  // 2) Insert the inline gtag initializer
  const inline = document.createElement("script")
  inline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}', { anonymize_ip: true });
  `
  document.head.appendChild(inline)

  window._gaLoaded = true
}

export const onInitialClientRender = () => {
  // Prevent native scroll restoration if you still want manual control
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }

  // If they’ve already accepted in a prior session, load GA now
  if (getCookieConsentValue() === "true") {
    loadGoogleAnalytics()
  }
}

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="gatsbyCookieConsent"
      style={{ background: "#2B373B" }}
      buttonStyle={{
        background: "linear-gradient(90deg, #ff69b4, #add8e6, #dda0dd)",
        backgroundSize: "300% 300%",
        border: "none",
        borderRadius: "65px",
        color: "#202020",
        fontFamily: "Poppins, sans-serif",
        padding: "10px 18px",
        cursor: "pointer",
        fontSize: "1rem",
        position: "relative",
        zIndex: "10",
        fontWeight: "500",
        display: "inline-block",
        animation: "gradientAnimation 10s ease infinite",
      }}
      declineButtonStyle={{
        borderRadius: "65px",
        backgroundColor: "transparent",
        border: "2px solid white",
        fontFamily: "Poppins, sans-serif",
        color: "white",
        padding: "8px 16px",
        fontSize: "1rem",
        cursor: "pointer",
      }}
      enableDeclineButton
      expires={150}
      onAccept={() => {
        console.log("🍪 User accepted cookies – loading GA")
        loadGoogleAnalytics()
      }}
      onDecline={() => {
        console.log("🚫 User declined cookies – no GA")
        // Optional: remove any existing GA cookies here
        // document.cookie = `_ga=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`
      }}
    >
      We use cookies to improve your experience. By using this site, you accept our use of cookies.
    </CookieConsent>
  </>
)
